"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformSubAccountParsedResponse = void 0;
/* eslint-disable @typescript-eslint/camelcase */
const Date_1 = require("./Date");
function transformSubAccountParsedResponse(account) {
    return {
        accountSubName: account.account_sub_name,
        accountSubNumber: account.account_sub_number,
        accountingSystemId: account.accounting_systemid,
        accountType: account.account_type,
        balance: account.balance ? Number(account.balance) : account.balance,
        createdAt: account.created_at && (0, Date_1.transformDateResponse)(account.created_at, Date_1.DateFormat['YYYY-MM-DD hh:mm:ss']),
        currencyCode: account.currency_code,
        custom: account.custom,
        id: account.id,
        parentId: account.parentid,
        subAccountId: account.sub_accountid,
        transactionPosted: account.transaction_posted,
    };
}
exports.transformSubAccountParsedResponse = transformSubAccountParsedResponse;
//# sourceMappingURL=SubAccount.js.map